import React, { useState } from "react";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
  RadioGroup,
  FormControlLabel,
  Radio,
  Card,
  CardMedia,
  CardContent,
  Alert,
} from "@mui/material";

import { useAuth } from "../../context/AuthContext";
import { checkoutOrder } from "../../services/source";

const CheckoutDialog = ({ open, onClose, cart, setCart }) => {
  const { customer } = useAuth();
  const [paymentMethod, setPaymentMethod] = useState("Cash");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const total = cart.reduce(
    (sum, item) => sum + Number(item.price) * item.quantity,
    0,
  );
  const handlePurchase = async () => {
    if (!customer) {
      setMessage("Faça o Login primeiro.");
      return;
    }

    const order = {
      customer_id: customer.id,
      payment_method: paymentMethod,

      items: cart.map((item) => ({
        product_id: item.id,
        product_code: item.product_code,
        quantity: item.quantity,
        price: item.price,
      })),

      total: total,
    };

    try {
      await checkoutOrder(order);

      setMessage("Compra realizada com sucesso.");

      setSuccess(true);

      setCart([]);
    } catch (error) {
      setMessage("Falha ao realizar a compra.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Confirmar Compra</DialogTitle>

      <DialogContent>
        {message && <Alert severity="success">{message}</Alert>}

        <Box mb={2}>
          <Typography variant="h6">Cliente</Typography>

          <Typography>
            <small style={{ color: "text.secondary" }}>Nome:</small>
            {customer?.fullname}
          </Typography>

          <Typography>
            <small style={{ color: "text.secondary" }}>Email:</small>
            {customer?.email}
          </Typography>

          <Typography>
            <small style={{ color: "text.secondary" }}>Telefone:</small>
            {customer?.phone}
          </Typography>
        </Box>

        <Divider />

        <Typography
          variant="h6"
          sx={{
            mt: 2,
          }}
        >
          Produtos
        </Typography>

        {cart.map((item, index) => (
          <Card
            key={index}
            sx={{
              display: "flex",

              mt: 2,
            }}
          >
            <CardMedia
              component="img"
              image={item.image}
              sx={{
                width: 100,

                height: 100,

                objectFit: "cover",
              }}
            />

            <CardContent>
              <Typography fontWeight="bold">{item.title}</Typography>
              <Typography variant="body2" color="text.secondary">
                Codigo Produto: {item.product_code}
              </Typography>

              <Typography>Quantidade: {item.quantity}</Typography>

              <Typography>
                Preço: {Number(item.price).toLocaleString()}{" "}
                {item.location?.toLowerCase().includes("lisboa") ? "€" : "Kz"}
              </Typography>

              <Typography>
                Subtotal:
                {(Number(item.price) * item.quantity).toLocaleString()}
                {item.location?.toLowerCase().includes("lisboa") ? "€" : "Kz"}
              </Typography>
            </CardContent>
          </Card>
        ))}

        <Divider sx={{ my: 3 }} />

        <Typography variant="h5">
          Total:
          {total.toLocaleString()}
          {cart.some((item) => item.location?.toLowerCase().includes("lisboa"))
            ? "€"
            : "Kz"}
        </Typography>

        <Typography
          sx={{
            mt: 3,
          }}
          variant="h6"
        >
          Método de Pagamento
        </Typography>

        <RadioGroup
          value={paymentMethod}
          onChange={(e) => setPaymentMethod(e.target.value)}
        >
          <FormControlLabel value="Cash" control={<Radio />} label="Dinheiro" />

          <FormControlLabel
            value="Bank Transfer"
            control={<Radio />}
            label="Transferência Bancária"
          />
        </RadioGroup>
      </DialogContent>

      <DialogActions>
        {!success && <Button onClick={onClose}>Cancelar</Button>}

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            width: "100%",
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              if (success) {
                onClose();
                setSuccess(false);
                setMessage("");
              } else {
                handlePurchase();
              }
            }}
          >
            {success ? "Fechar" : "Confirmar Compra"}
          </Button>

          {success && (
            <Typography
              variant="body2"
              sx={{
                mt: 1,
                textAlign: "left",
                color: "success.main",
              }}
            >
              Compra realizada com sucesso. Pode verificar no{" "}
              <ShoppingBasketIcon
                fontSize="small"
                sx={{
                  verticalAlign: "middle",
                }}
              />
            </Typography>
          )}
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default CheckoutDialog;
